import UIHelper from '../../../../helpers/UIHelper';
import { adaptFinanceInvoiceSingle } from './financeInvoiceSingleAdapter';

export const invoicesAdapter = (data) => {
  if (!data) {
    return [];
  }

  const newArr = [];

  const prepareData = (i) => {
    const receipts = UIHelper.numberWithDot(i.receipts_sum);
    // const visitors = UIHelper.numberWithDot(UIHelper.replaceDotToComma(i.visitors_sum));
    const visitors = UIHelper.numberWithDot(i.visitors_sum);
    return {
      ...i,
      'shopping_centers.title': i?.company?.shopping_center?.title,
      shopping_center_title: i?.company?.shopping_center?.title,
      company_name: i?.company?.name,
      receipts_sum: receipts,
      pieces_sum: UIHelper.numberWithDot(i.pieces_sum),
      visitors_sum: visitors,
      upt: UIHelper.numberWithDot(UIHelper.replaceDotToComma(i.upt)),
      atv_sum: UIHelper.numberWithDot(UIHelper.replaceDotToComma(i.atv)),
      conversion_rate_sum: UIHelper.replaceDotToComma(i.cr),
      invoice_date: i?.date,
      upt_sum: UIHelper.numberWithDot(UIHelper.replaceDotToComma(i.upt)),
    };
  };

  if (Array.isArray(data)) {
    data.forEach((i) => {
      newArr.push(prepareData(i));
    });

    return newArr;
  }

  return prepareData(data);
};

/** List rows + single GET response (company + invoices[]). */
export const financeInvoicesAdapter = (data) => {
  if (data?.allData?.invoices && Array.isArray(data.allData.invoices)) {
    return adaptFinanceInvoiceSingle(data.allData);
  }
  return invoicesAdapter(data);
};
